var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.item.id)?_c('div',{staticClass:"course__btn"},[_c('router-link',{staticClass:"link-btn",attrs:{"to":_vm.to}},[_vm._v(" "+_vm._s(_vm.$t(_vm.label))+" "),_c('i',{staticClass:"far fa-arrow-right"}),_c('i',{staticClass:"far fa-arrow-right"})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }